import { h } from 'preact';
import clsx from 'clsx';

const ProductStickyButton = ({ product, variant, isVisible, children }) => (
  <div
    className={clsx('lg:px-[60px] fixed bottom-0 left-0 w-full z-40', {
      'ease-in duration-300 translate-y-full': !isVisible,
      'ease-out duration-300 "translate-y-0': isVisible,
    })}
  >
    <div className="overflow-hidden w-full lg:h-[74px] h-[64px] lg:rounded-t-lg  border-t lg:border-l lg:border-r lg:border-grey-B4 border-grey-D0 bg-white lg:flex lg:justify-between">
      <div className="flex-1 min-w-0 hidden lg:flex items-center">
        {!variant && !!product.images.length && (
          <img
            src={product.images[0].src}
            alt={product.images[0].alt}
            className="w-auto h-full hidden md:block"
          />
        )}
        {!!variant && !!product.images.length && (
          <img
            src={variant.image.src}
            alt={variant.image.alt}
            className="w-auto h-full hidden md:block"
          />
        )}

        <div className="body pl-3">{product.title}</div>
        {variant.selectedOptions?.length && (
          <div className="body-xs text-grey-5C flex">
            {variant.selectedOptions?.map((i, index) => (
              <div key={index} className="flex">
                <div className="pl-5 pr-5">|</div>
                <div>{i.value}</div>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="[&_button]:lg:w-[366px] [&_button]:h-[44px] [&_button]:w-full p-2.5 lg:pr-5 lg:py-[15px]">
        {children}
      </div>
    </div>
  </div>
);

export default ProductStickyButton;
